const INITIAL_STATE = {
  inventoryFilter: '',
  selectedInventory: 0
};

export const inventoryReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'UPDATE_ADMIN_INVENTORY_PAGE_FILTER_STRING':
      return {
        ...state,
        inventoryFilter: action.payload
      };
    case 'UPDATE_ADMIN_INVENTORY_PAGE_SELECTED_INVENTORY':
      return {
        ...state,
        selectedInventory: action.payload
      };
    default:
      return state;
  }
};
